import {btoa} from 'abab'
import {Suspense} from 'react'
import {For} from 'react-loops'
import {graphql, useLazyLoadQuery} from 'react-relay/hooks'
import {Link, useParams} from 'react-router-dom'
import {Avatar, Box, BoxProps, Button, Stack} from '@chakra-ui/react'

import {FanListQuery} from './__generated__/FanListQuery.graphql'

import {FanListSkeleton} from './FanListSkeleton'
import {Image} from 'components/Image'

export function FanListSuspense(props: BoxProps) {
  return (
    <Suspense fallback={<FanListSkeleton />}>
      <FanList {...props} />
    </Suspense>
  )
}

export function FanList(props: BoxProps) {
  const {userId} = useParams()
  const {user} = useLazyLoadQuery<FanListQuery>(
    graphql`
      query FanListQuery($userId: ID!) {
        user(id: $userId) {
          followers(first: 8) {
            pageInfo {
              total
            }
            edges {
              node {
                firstName
                lastName
                resourcePath
                avatar {
                  transformedSrc(maxHeight: 48, maxWidth: 48)
                }
              }
            }
          }
        }
      }
    `,
    {
      userId: btoa(`User:${userId}`),
    }
  )

  return (
    <Box bg="white" borderRadius="md" boxShadow="sm" {...props}>
      <Stack
        alignItems="center"
        borderBottom="1px solid"
        borderBottomColor="gray.100"
        direction="row"
        mx={4}
        py={4}
        spacing="auto"
      >
        <Box color="green.500" fontWeight="medium">
          {user.followers.pageInfo.total} fans
        </Box>
        <Button as={Link} size="sm" to="fans" colorScheme="green">
          See more
        </Button>
      </Stack>
      <For
        of={user.followers.edges.map(({node}) => node)}
        as={(user) => (
          <Box
            as={Link}
            alignItems="center"
            d="flex"
            px={4}
            py={2}
            to={user.resourcePath}
            _hover={{bg: `green.50`}}
          >
            {user.avatar ? (
              <Image borderRadius="md" src={user.avatar.transformedSrc} />
            ) : (
              <Avatar borderRadius="md" size="md" />
            )}
            <Box ml={2}>
              <Box color="gray.700" fontSize="md">
                {user.firstName}
              </Box>
              <Box color="gray.500" fontSize="sm">
                {user.lastName}
              </Box>
            </Box>
          </Box>
        )}
      />
    </Box>
  )
}
